<p>customer-report-model works!</p>
<!-- <app-modal #modalReportCustomer [modalConfig]="modalConfigReport"> -->
<!-- <app-customer-report-model #modalReportCustomer [modalConfig]="modalConfigReport">
<pdf-viewer 
[src]="image"
[rotation]="0"
[original-size]="false"
[show-all]="true"
[fit-to-page]="false"
[zoom]="1"
[zoom-scale]="'page-width'"
[stick-to-page]="false"
[render-text]="true"
[external-link-target]="'blank'"
[autoresize]="true"
[show-borders]="false"
class="viewer"
>
</pdf-viewer>
</app-customer-report-model>
</app-modal> -->